import { FIELD_MAX_LENGTHS, VALIDATION_MESSAGES } from 'shared'
import { z } from 'zod'
import { validateForm } from '@/lib/form-validation'

/**
 * タスクフォームのバリデーションスキーマ
 */
export const taskSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, VALIDATION_MESSAGES.REQUIRED)
    .max(
      FIELD_MAX_LENGTHS.OPPORTUNITY_TASK_TITLE,
      VALIDATION_MESSAGES.maxLength(FIELD_MAX_LENGTHS.OPPORTUNITY_TASK_TITLE),
    ),
  description: z
    .string()
    .trim()
    .min(1, VALIDATION_MESSAGES.REQUIRED)
    .max(
      FIELD_MAX_LENGTHS.OPPORTUNITY_DESCRIPTION,
      VALIDATION_MESSAGES.maxLength(FIELD_MAX_LENGTHS.OPPORTUNITY_DESCRIPTION),
    ),
  statusId: z.number({ message: VALIDATION_MESSAGES.REQUIRED_SELECT }),
  memberId: z.number({ message: VALIDATION_MESSAGES.REQUIRED_SELECT }),
})

/**
 * タスクフォームのフィールドエラーを取得
 */
export function getTaskFieldErrors(data: {
  title: string
  description: string
  statusId: number | null
  memberId: number | null
}): Record<string, string> {
  return validateForm(taskSchema, data).errors
}
